import { notice, message, confirm } from '../feedback/index';
import CODES from './codes';
/**
 * 自定义基类
 */
class YNFError extends Error {
  static codes = CODES;

  constructor (code, message = '', params = {}) {
    super(code, message, params);
    this.name = this.constructor.name;

    // 默认值
    this.code = code;
    this.message = message;
    if (typeof this.code === 'string') { // 兼容不传错误码
      this.message = this.code;
      this.code = YNFError.codes[0];
    }
    this.params = params;
  }

  execute () {
    // 事件派发
    this.dispatch();
    return this;
  }

  getMessage () {
    if (!this.message && YNFError.codes.indexOf(this.code) > -1) {
      return this.code.text + lang.templateByUuid('UID:P_CORE-YNF-FE_1894FE9204500046', '\n错误码：') + this.code.code
    }
    return this.message;
  }

  dispatch () {
    const event = new Event('alertError');
    event.key = this.name;
    event.params = { code: this.code, message: this.message, params: this.params, stack: this.stack };
    if (this.type) event.params.type = this.type;
    console.error(this.code, this.message);
    window.dispatchEvent(event);
  }

  log (type, ...params) {
    console[type]('%c ' + this.name + ' console. + ' + type + ' + ==>', 'color: #c8b1f1', ...params);
  }
}

/**
 * 全局提示
 */
class Message extends YNFError {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super(...arguments);
  }

  error () {
    this.execute('danger');
  }

  warning () {
    this.execute('warning');
  }

  info () {
    this.execute('info');
  }

  success () {
    this.execute('success');
  }

  execute (type) {
    this.type = type;
    if (!message?.[type]) return;
    message[type](this.getMessage());
    super.dispatch();
  }
}

/**
 * 右下角弹窗
 */
class Notification extends YNFError {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super(...arguments);
  }

  error () {
    this.execute('error');
  }

  warning () {
    this.execute('warning');
  }

  info () {
    this.execute('info');
  }

  success () {
    this.execute('success');
  }

  execute (type) {
    this.type = type;
    if (!notice) return;
    notice({
      title: lang.templateByUuid('UID:P_CORE-YNF-FE_1894FE9204500044', '通知'),
      content: this.getMessage(),
      color: type,
      ...this.params
    })
    super.dispatch();
  }
}

/**
 * 确认弹窗
 */
class Confirm extends YNFError {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super(...arguments);
  }

  execute () {
    if (!confirm) return;
    confirm({
      title: lang.templateByUuid('UID:P_CORE-YNF-FE_1894FE9204500045', '确认'),
      content: this.getMessage(),
      ...this.params
    })
    super.dispatch();
  }
}

/**
 * 异常捕获
 */
class CatchError {
  constructor (props) {
    this.errorCodes = CODES;
  }

  /**
   * 初始化
   * @param {} props
   */
  init () {
    /**
     * 全局异常捕获
     */
    // this.addEventListener();

    /**
     * 创建 Error类
     */
    this.createErrors();

    /**
      * 创建 Error错误码
      */
    this.createErrorCode();
  }

  /**
   * 创建所有常类
   */
  createErrors () {
    // this.createError('Error', YNFError);
    // message
    this.createError('MessageError', Message, 'error');
    // notice
    this.createError('NotificationError', Notification, 'error');
    // confirm
    this.createError('ConfirmError', Confirm);
  }

  /**
   * 创建新的异常类
   */
  createError (name, Error, property) {
    window[name] = function () {
      if (!property) property = 'execute';
      return new Error(...arguments)?.[property]?.();
    };
    Object.defineProperty(window, name, {
      writable: false,
      configurable: false,
      enumerable: false
    })
  }

  /**
   * 创建所有异常code
   */
  createErrorCode () {
    this.errorCodes.forEach((code) => {
      window.Error[code.code] = code;
      Object.defineProperty(window.Error, code.code, {
        writable: false,
        configurable: false,
        enumerable: false
      })
    })
  }

  // /**
  //  * 异常捕获
  //  * @param {error} error
  //  */
  // handleError (event) {
  //   // console.debug('%c 异常捕获 ==>', 'color: #c8b1f1', event);
  // }

  // addEventListener () {
  //   /**
  //    * 全局异常捕获 + 资源加载错误
  //    */
  //   window.addEventListener('error', (event) => this.handleError(event.error), true);
  //   /**
  //   * 捕获没有catch的Promise错误
  //   */
  //   window.addEventListener('unhandledrejection', (event) => this.handleError(event.reason), true)
  //   /**
  //    * 捕获弹出类异常
  //    */
  //   window.addEventListener('alertError', (event) => this.handleError(event), true);
  // }

  // removeEventListener () {
  //   window.removeEventListener('error', (event) => this.handleError(event.error), true);
  //   window.removeEventListener('unhandledrejection', (event) => this.handleError(event), true);
  //   window.removeEventListener('alertError', (event) => this.handleError(event), true);
  // }
}

const catcherror = new CatchError();
if (!window.Error.E00000) {
  catcherror.init();
}
export default catcherror;
